const isVTLDomain = window.location.origin.endsWith("vtlaldmn.com")

export const ENV_VARS = {
    SYSTEM_API_URL: isVTLDomain ? import.meta.env.SYSTEM_API_VTL_URL : import.meta.env.SYSTEM_API_URL,
    SYSTEM_WS_URL_ADMIN: isVTLDomain ? import.meta.env.SYSTEM_WS_VTL_URL_ADMIN : import.meta.env.SYSTEM_WS_URL_ADMIN,
    SYSTEM_WS_URL_SITE: isVTLDomain ? import.meta.env.SYSTEM_WS_VTL_URL_SITE : import.meta.env.SYSTEM_WS_URL_SITE,
    SYSTEM_WS_URL_JOBS: isVTLDomain ? import.meta.env.SYSTEM_WS_VTL_URL_JOBS : import.meta.env.SYSTEM_WS_URL_JOBS
};